export default {
  price: {
    id: 'us_telco_comparators_noble_mobile_offer_card_price',
    defaultMessage: '$50.00',
  },
  trustpilotRating: {
    id: 'us_telco_comparators_noble_mobile_offer_card_trustpilot_rating',
    defaultMessage: '4.5',
  },
  name: {
    id: 'us_telco_comparators_noble_mobile_offer_card_name',
    defaultMessage: 'Noble Mobile',
  },
  promoTitle: {
    id: 'us_telco_comparators_noble_mobile_offer_card_promo_title',
    defaultMessage: '$150 off your phone',
  },
  promoContent: {
    id: 'us_telco_comparators_noble_mobile_offer_card_promo_content',
    defaultMessage:
      'Save on any Back Market phone with 6 months of a Noble plan.',
  },
  benefitNetwork: {
    id: 'us_telco_comparators_noble_mobile_offer_card_benefit_network',
    defaultMessage: 'T-mobile network',
  },
  benefitUnlimited: {
    id: 'us_telco_comparators_noble_mobile_offer_card_benefit_unlimited',
    defaultMessage: 'Unlimited data, call and text',
  },
  benefitMoneyBack: {
    id: 'us_telco_comparators_noble_mobile_offer_card_benefit_money_back',
    defaultMessage: 'Get money back for any unused data per month',
  },
  modalStep1: {
    id: 'us_telco_comparators_noble_mobile_offer_card_modal_step_1',
    defaultMessage:
      "Sign up for a plan on Noble's site. Find the promo code in your Noble account at the top of your dashboard.",
  },
  modalStep2: {
    id: 'us_telco_comparators_noble_mobile_offer_card_modal_step_2',
    defaultMessage:
      'Select and customize the unlocked phone you want on Back Market.',
  },
  modalStep3: {
    id: 'us_telco_comparators_noble_mobile_offer_card_modal_step_3',
    defaultMessage: 'Apply your code at checkout.',
  },
  modalCtaLabel: {
    id: 'us_telco_comparators_noble_mobile_offer_card_modal_cta_label',
    defaultMessage: 'Get started on Noble Mobile',
  },
  modalCtaLink: {
    id: 'us_telco_comparators_noble_mobile_offer_card_modal_cta_link',
    defaultMessage: 'https://noblemobile.com/',
  },
}
